import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCart } from "@sdk/react";
import React, { useState } from "react";

var ProductListItemQuantity = function ProductListItemQuantity(_ref) {
  var line = _ref.line;

  var _useState = useState(line.quantity),
      _useState2 = _slicedToArray(_useState, 2),
      tempQuantity = _useState2[0],
      setTempQuantity = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isTooMuch = _useState4[0],
      setIsTooMuch = _useState4[1];

  var _useCart = useCart(),
      updateItem = _useCart.updateItem;

  function quantityChange(val) {
    // onQuantityChange(Number(val), line.variant.id);
    updateItem(line.variant.id, Number(val), line.productAttributes);
  }

  function handleQuantityChange(value) {
    setTempQuantity(Number(value));
    setIsTooMuch(!!Number(value) && Number(value) > line.variant.quantityAvailable);
  }

  function handleBlurQuantityInput() {
    var newQuantity = Number(tempQuantity);

    if (!Number(newQuantity) || newQuantity <= 0) {
      newQuantity = line.quantity;
    } else if (newQuantity > line.variant.quantityAvailable) {
      newQuantity = line.variant.quantityAvailable;
    }

    if (line.quantity !== newQuantity) {
      quantityChange(newQuantity);
    }

    if (tempQuantity !== newQuantity) {
      setTempQuantity(newQuantity);
    }

    setIsTooMuch(false);
  }

  function add() {
    if (line.quantity < line.variant.quantityAvailable) {
      setTempQuantity(line.quantity + 1);
      quantityChange(line.quantity + 1);
    }
  }

  function substract() {
    if (line.quantity > 1) {
      setTempQuantity(line.quantity - 1);
      quantityChange(line.quantity - 1);
    }
  }

  var handleFocus = function handleFocus(event) {
    event.target.select();
  };

  return React.createElement("div", {
    className: "cart__list__item__quantity"
  }, React.createElement("div", {
    className: "cart__list__item__quantity-content"
  }, React.createElement("button", {
    className: "cart__list__item__quantity-btn substract",
    type: "button",
    onClick: substract
  }, "-"), React.createElement("input", {
    type: "number",
    value: tempQuantity,
    onFocus: handleFocus,
    onBlur: handleBlurQuantityInput,
    onChange: function onChange(e) {
      return handleQuantityChange(e.target.value);
    },
    className: "cart__list__item__quantity-input" // disabled

  }), React.createElement("button", {
    className: "cart__list__item__quantity-btn add",
    type: "button",
    onClick: add
  }, "+")), React.createElement("div", {
    className: "cart__list__item__quantity-error"
  }, isTooMuch && "Maximum quantity is ".concat(line.variant.quantityAvailable)));
};

export default ProductListItemQuantity;